var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20106_49869)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.917 0.833008H6.25033C5.10033 0.833008 4.16699 1.76634 4.16699 2.91634V17.083C4.16699 18.233 5.10033 19.1663 6.25033 19.1663H12.917C14.067 19.1663 15.0003 18.233 15.0003 17.083V2.91634C15.0003 1.76634 14.067 0.833008 12.917 0.833008ZM9.58366 18.333C8.89199 18.333 8.33366 17.7747 8.33366 17.083C8.33366 16.3913 8.89199 15.833 9.58366 15.833C10.2753 15.833 10.8337 16.3913 10.8337 17.083C10.8337 17.7747 10.2753 18.333 9.58366 18.333ZM13.3337 14.9997H5.83366V3.33301H13.3337V14.9997Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20106_49869"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.3eb81cd005882036fb626b4b50a6c8b0.svg";
export { ForwardRef as ReactComponent };